import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted } from 'vue'
  import FleetLine from '@/components/fleet/FleetLine.vue'  
  import FleetNew from '@/components/fleet/FleetNew.vue'  
  import MissionFilter from '@/components/mission/MissionFilter.vue'  
  import MissionOperatorFilter from '@/components/mission/MissionOperatorFilter.vue'  
  import MissionFilterIcon from '@/components/mission/MissionFilterIcon.vue'   
  import { buildMissionUIStateId } from '@/models/ui/MissionUiState'
  import { router } from '@/mainjs.js'
  import store from '@/store';
  import { AloDbFleet } from '@/models/alodb/AloDbFleet'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'FleetList',
  setup(__props) {

  const height = ref(100)
  const liste = ref<HTMLElement>()

  const showAddFleet = ref(false)

  // Computed properties from store getters
  const drawerMissions = computed(() => store.myGetters.drawerMissions)
  const ongoingMissionActive = computed(() => store.myGetters.ongoingMissionActive)
  const simulatedMissionActive = computed(() => store.myGetters.simulatedMissionActive)
  const missionsOngoingLoading = computed(() => store.myGetters.missionsOngoingLoading)
  const missionsPassedLoading = computed(() => store.myGetters.missionsPassedLoading)
  const missionsPassedLoaded = computed(() => store.myGetters.missionsPassedLoaded)
  const allFleetVisibility = computed(() => store.myGetters.allFleetVisibility)
  const filteredFleet = computed(() => store.myGetters.filteredFleet)
  const canAddFleet = computed(() => store.myGetters.creationFleetTypes.length > 0)


  onMounted(() => {
    onResize()
  })

  function onResize() {
    if (liste.value) {
      height.value = liste.value.clientHeight
    }
  }

  function onContextMenu() {
    alert("ok")
  }

  function showFinishedMission() {
    store.myActions.UI_UNACTIVE_ONGOING_MISSION_VIEW()
  }

  async function addNewFleet() {
    await store.myActions.ADMINFLEET_SELECT_DETAIL(-1);
    showAddFleet.value = true
  }

  async function saveFleet() {
    const result = await store.myActions.ADMINFLEET_SAVE_REQUEST() as AloDbFleet
    showAddFleet.value = false    
    if((result?.id ??0) > 0)
    {      
      router.push({name:'FleetDetail',params:{fleetid:result.id!.toString()}})      
    }
  }

return { __sfc: true,height, liste, showAddFleet, drawerMissions, ongoingMissionActive, simulatedMissionActive, missionsOngoingLoading, missionsPassedLoading, missionsPassedLoaded, allFleetVisibility, filteredFleet, canAddFleet, onResize, onContextMenu, showFinishedMission, addNewFleet, saveFleet, FleetLine, FleetNew }
}

})